module.exports = __webpack_public_path__ + "static/img/guide2.29644e16.png";